export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const nuxtApp = useNuxtApp()
  onNuxtReady(() => {
    // eslint-disable-next-line no-console
    console.log(`Alfred version: ${config.public.alfredVersion}`)
    // eslint-disable-next-line no-console
    console.log(`Nuxt alfred version: ${nuxtApp.$config.public.alfredVersion}`)
    if (nuxtApp.$config.public.alfredVersion !== config.public.alfredVersion) {
      console.error('Alfred version mismatch')
    }
  })
})
